import React, { useEffect, useState } from "react";

import { useParams, useNavigate, useLocation } from "react-router-dom";
import { apiService } from "../../services";
import { Constants } from "@eagerdog/constants";
import { toast } from "../../components/Toast/ToastManager";
import { AxiosError } from "axios/index";
import { Helmet } from "react-helmet";
import { IUser } from "@eagerdog/interfaces";
import { helperService } from "../../services/helper.service";
import Loading from "../../components/Loading";

interface IProps {}

const ApproveDogProposedChanges: React.FC<IProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { eid, dogId } = useParams();
  const [, setEvent] = useState<any>();

  const user:IUser = helperService.getUser();

  if (!helperService.isLoggedIn()) {
    navigate(`/login?r=${location.pathname}`);
  }

  useEffect(() => {
    if (eid && dogId && user.user_type === Constants.user_type.owner) {
      apiService.getEventSummaryForHandle(eid).then((response) => {
        setEvent(response);
        if (response._id) {
          apiService.approveDogProposedChanges(dogId, response._id).then((approveResponse) => {
            toast.show({
              title: "Dog Settings Saved",
              content: "Your dog's profile changes have been saved successfully.",
              duration: 6000,
              type: "success",
            });
            navigate(`/`);
          }).catch((e: AxiosError) => {
            toast.show({
              title: "Approve Proposed Changes",
              content: "Unable to approve changes",
              duration: 10000,
              errorDetails: e,
              type: "fail",
            });
          });
        }
      }).catch((e: AxiosError) => {
        toast.show({
          title: "Get Event",
          content: "Unable to get shows",
          duration: 10000,
          errorDetails: e,
          type: "fail",
        });
      })
    }
  }, [eid, dogId]);

  return (
    <div className="EventLottery">
      <Helmet>
        <title>Approving Proposed Changes</title>
        <meta name="description" content={"Approving Proposed Changes"} />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Loading/>
    </div>
  );
};

export default ApproveDogProposedChanges;